import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getBulkProducts} from "../BulkProduct/actions";
import {Button, Card, Form, Input, InputNumber, notification, Select} from 'antd';

import {receiveBulkProduct} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";
import units from "../Product/units";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;
const Option = Select.Option;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ReceiveBulkProductForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.dispensaryId !== prevProps.dispensaryId) this._load();
  }

  _load() {
    const {dispensaryId} = this.props;
    this.props.getBulkProducts({dispensaryId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.receiveBulkProduct({...values, dispensaryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, bulkProducts} = this.props;
    return (
      <Card title="Receive Bulk Product">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Bulk Product"
          >
            {getFieldDecorator('bulkProductId', {
              rules: [{
                required: true,
                message: 'Bulk Product is required'
              }]
            })(
              <Select>
                {bulkProducts.map(({bulkProductId, name}) => <Option key={bulkProductId}
                                                                     value={bulkProductId}>{name}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Lot Number"
          >
            {getFieldDecorator('lotNumber', {
              rules: [{
                required: true,
                message: 'Lot Number is required'
              }]
            })(
              <Input/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Quantity"
          >
            {getFieldDecorator('quantity', {
              rules: [{
                required: true,
                message: 'Quantity is required'
              }, {
                type: 'number',
                min: 0.001,
                message: 'Must be greater or equal to 0.001'
              }]
            })(
              <InputNumber precision={3}/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Unit"
          >
            {getFieldDecorator('unit', {
              rules: [{
                required: true,
                message: 'Unit is required'
              }]
            })(
              <Select>
                {units.map(({value, display}) => <Option key={value} value={value}>{display}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Net Cost"
          >
            {getFieldDecorator('netCost', {
              rules: [{
                required: true,
                message: 'Net cost is required'
              }, {
                type: 'number',
                min: 0,
                message: 'Must be at least zero'
              }]
            })(
              <InputNumber precision={2}/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Receive Bulk Product
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

ReceiveBulkProductForm.propTypes = {
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string.isRequired,
  receiveBulkProduct: PropTypes.func.isRequired,
  bulkProducts: PropTypes.array.isRequired,
  getBulkProducts: PropTypes.func.isRequired,
};

const ReceiveBulkProductPage = Form.create()(ReceiveBulkProductForm);

const mapStateToProps = state => ({
  loading: state.bulkConsignment.receivingBulkProduct || state.bulkProduct.bulkProductsLoading,
  dispensaryId: state.dispensary.selectedDispensaryId,
  bulkProducts: state.bulkProduct.bulkProducts,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  receiveBulkProduct,
  getBulkProducts,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveBulkProductPage);



// WEBPACK FOOTER //
// ./src/BulkConsignment/ReceiveBulkProductPage.js